module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page",
    attrs: {
      "id": "contactDebtorList"
    }
  }, [_c('div', {
    staticClass: "page-content"
  }, [_vm._m(0), _vm._v(" "), _c('f7-searchbar', {
    staticClass: "search",
    attrs: {
      "cancel-link": "Cancel",
      "search-list": "#add-contact-group-contact-list",
      "placeholder": "Search in contact list"
    }
  }), _vm._v(" "), _c('f7-list', {
    staticClass: "addGroupMemberGroupList",
    attrs: {
      "id": "add-contact-group-contact-list",
      "contacts": ""
    }
  }, _vm._l((this.contactAlphabetList), function(group, key) {
    return _c('f7-list-group', {
      key: key
    }, [_c('f7-list-item', {
      attrs: {
        "title": key,
        "group-title": ""
      }
    }), _vm._v(" "), _vm._l((group), function(contact) {
      return _c('li', {
        on: {
          "change": function($event) {
            return _vm.changeItem()
          }
        }
      }, [_c('label', {
        staticClass: "label-checkbox item-content"
      }, [_c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (_vm.contactSelected),
          expression: "contactSelected"
        }],
        staticClass: "inputContact",
        attrs: {
          "type": "checkbox",
          "name": "addContactGroupContactListCheckbox"
        },
        domProps: {
          "value": contact.id,
          "checked": Array.isArray(_vm.contactSelected) ? _vm._i(_vm.contactSelected, contact.id) > -1 : (_vm.contactSelected)
        },
        on: {
          "change": function($event) {
            var $$a = _vm.contactSelected,
              $$el = $event.target,
              $$c = $$el.checked ? (true) : (false);
            if (Array.isArray($$a)) {
              var $$v = contact.id,
                $$i = _vm._i($$a, $$v);
              if ($$el.checked) {
                $$i < 0 && (_vm.contactSelected = $$a.concat([$$v]))
              } else {
                $$i > -1 && (_vm.contactSelected = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
              }
            } else {
              _vm.contactSelected = $$c
            }
          }
        }
      }), _vm._v(" "), _c('div', {
        staticClass: "item-media"
      }, [_c('i', {
        staticClass: "icon icon-form-checkbox"
      })]), _vm._v(" "), _c('div', {
        staticClass: "item-inner"
      }, [_c('div', {
        staticClass: "item-title"
      }, [_vm._v(_vm._s(contact.label))])])])])
    })], 2)
  }), 1), _vm._v(" "), _c('div', {
    staticClass: "row justify-content-start"
  }, [_c('div', {
    staticClass: "offset-md-5 col-md-3"
  }, [_c('button', {
    staticClass: "buttonWidth streammindContactListButton button-inner-color okButtonContactList",
    on: {
      "click": _vm.goBack
    }
  }, [_c('span', [_vm._v("OK")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('button', {
    staticClass: "buttonWidth streammindContactListButton button-inner-color",
    on: {
      "click": _vm.cancel
    }
  }, [_c('span', [_vm._v("Cancel")])])])]), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "layoutBottomContactList"
  })], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "navbar"
  }, [_c('div', {
    staticClass: "navbar-inner"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "toolbarPageBottomBlank"
  })])
}]}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-071ebefe", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-071ebefe","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/contacts/CMAddContactGroupContactList.vue
// module id = 1615
// module chunks = 2